import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { PreferencesService } from 'src/app/features/myalcon-preferences/services/preferences.service';
import { ProfileService } from 'src/app/core/services/common/profile.service';
import { OktaAuth, IDToken } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { jwtDecode } from 'jwt-decode';
import { CountryISO, NgxIntlTelInputComponent, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { Router } from '@angular/router';
import { DataTranferService } from './services/data-tranfer.service';
import { AuditUserLogsService } from 'src/app/core/services/common/audit-user-logs.service';
import { CommunicationService } from 'src/app/core/services/common/communication-service.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { HttpHelperService } from 'src/app/core/services/common/http-helper.service';


export class Preference {
  name!: string;
  value!: boolean;
}

export class genericObject {
  prefrenceID!: string;
  preferencetype!: string;
  description!: string;
  status!: string;
  visible!: boolean;
  sequenceId: any;
}

@Component({
  selector: 'app-myalcon-preferences',
  templateUrl: './myalcon-preferences.component.html',
  styleUrls: ['./myalcon-preferences.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('hidden', style({ opacity: 0, transform: 'translateY(-10px)' })),
      state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('hidden => visible', animate('0.5s ease-in')),
      transition('visible => hidden', animate('0.3s ease-out'))
    ])
  ]
})
export class MyalconPreferencesComponent {
  [x: string]: any;
  @Output() childEvent = new EventEmitter<string>();
  invalidNo = false;
  inphone: any;
  isValidPhoneNumber: any;
  public loading: boolean = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  public emailId: string;
  public inputPhone: string | any;
  public myIcon: any = null;
  public selectedButton = 'oval-button-selected';
  public unSelectedButton = 'oval-button-unselected';
  public label = 'Edit Prefrences';
  public preferences: genericObject[] = [];
  public comchannel: genericObject[] = [];
  public scheduleType: string = '';
  //public preferencesUpdated: Preference[] = [];
  public areaofIntrest: genericObject[] = [];
  //public areaofIntestUpdated: Preference[] =[];
  public userPreferences: any[] | string[] = [];
  public showButton = true;
  public selectedEmailFrequency: string;
  public WeeklyFrequency: string = 'Weekly';
  public MonthlyFrequency: string = 'Monthly';
  public UnsubscribeFrequency: string = 'Unsubscribe';
  public SnoozFrequency: string = 'Snooz';
  public Message: string = '';
  public currentTimeInGMT: any;
  public isDisable: boolean = false;
  public appid: any = '';
  public previousValue: string = '';
  public idToken: any = '';
  public clientId: any = '';
  isMarketingConsentChecked: boolean = false;
  isUnsubscribeConsentChecked: boolean = false;
  public formSubmitted: boolean = false;
  public formnotSubmitted: boolean = false;
  iselegibleForSubmit: boolean = false;
  phoneForm: any = new FormGroup({
    // checkArray: this.fb.array([]),
    phone: new FormControl(undefined, [Validators.required, Validators.minLength(5)])
  });
  userId?: string;
  userUpdatedPreferences: any;
  @ViewChild('phoneInput', { static: false }) phoneInputComponent: NgxIntlTelInputComponent;
  locationData: any;
  ipAddress: any;
  SearchCountryISO: any;
  consentGiven: any;
  preferenceForm: any;
  consentFormSubmitted: boolean = false;
  preferencesData: any[] = [];
  selectedPreferences: { [key: string]: boolean } = {}
  filteredPreferencesData: any = null;
  PreferencesData1: any = null;
  parsedData: any;
  orignalparsedData: any;
  usermappedDate: any;
  obj1: any;
  isMobileView: boolean = window.innerWidth <= 768;
  obj2: any;
  payload: any[] = [];
  enableSubmit: boolean = false;
userid: string = '';
currentMarketingConsentstatus: string = '';
enableUnsubscribe:string = '';
userMobileNumber :string= '';
consentFormError:  string  |  null =  null;
private  mobileNumberSource  = new  BehaviorSubject<string>('');  //  initial value  is  empty  string
showPreferredCategories : boolean = false;



  //ComparisonResult = Record<string, { opted: boolean }>;

  constructor(
    private fb: FormBuilder,
    public preferencesService: PreferencesService,
    public profileService: ProfileService,
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private router: Router,
    private audit: AuditUserLogsService,
    private phoneField: DataTranferService,
     private httpHelperService: HttpHelperService,
    public communcationService: CommunicationService
  ) {
    
    this.profileService.UserProfile.subscribe((data: any) => {
     if  (data.sub ===  undefined) { 
   
    } else {
    this.userid = data.sub;
 
     this.preferencesService.getExistingPreferences(); 
     this.preferencesService.getMyPreferencesess(this.userid); 
   
    }
    });
    

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileView = event.target.innerWidth <= 768;
  }


  //Gettting all the preperence on load
  ngOnInit(): void {
    this.loadPreferencesData();
    this.clearConsentErrors();

     this.loading = true;
    
    this.enableSubmit = true;
    this.showPreferredCategories = true;
    
    this.phoneForm = this.fb.group({
      phone: ['', Validators.required],
      // ... other controls
    });

  this.preferencesService.mobileNumber$.subscribe((number) =>  {
       this.phoneForm.patchValue({  phone:  number ||  ''  });
   });

    this.communcationService.getIpAndLocation().subscribe((data: any) => {
      this.locationData = data;
      this.ipAddress = data.ip;
      
      this.SearchCountryISO = this.locationData.country_code.toString();//CountryISO.India;
      
    });   
setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  clearConsentErrors():  void {
    this.consentFormError =  null;
   this.invalidNo  =  false;
   this.formSubmitted  =  false;
}


  loadPreferencesData() {
   
    this.parsedData =[];
    this.PreferencesData1 = [];
    this.myIcon = faUser;
    this.showButton = false;
    

  this.preferencesService.getExistingPreferences();
  this.preferencesService.getMyPreferencesess(this.userid);
    combineLatest([
    this.preferencesService.PreferenceMaster,
    this.preferencesService.MyPrefreeneces
  ]).subscribe(([preferenceMasterData, myPreferencesData]) => {
    if (preferenceMasterData && Array.isArray(preferenceMasterData)) {
      this.parsedData = this.transformConsentData(preferenceMasterData);
      this.PreferencesData1 = myPreferencesData;
      this.processMarketingConsent(this.PreferencesData1);
      this.updateParsedDataFromInput(this.PreferencesData1);
    }
  });

  }


  generateConsentPayload(): any[] {
    this.payload = []; // Reset payload for each generation
    // Loop over each purpose (e.g. "Marketing Consent (ECP)")
    Object.keys(this.parsedData).forEach(purposeKey => {
      const customPreferences: any[] = [];

      // Loop over each sub-group (e.g. "Communication Method")
      this.parsedData[purposeKey].forEach((preferenceObj: any) => {
        const preferenceName = Object.keys(preferenceObj)[0];
        const optionsArray = preferenceObj[preferenceName];

        const options = optionsArray.map((opt: any) => {
          const key = Object.keys(opt)[0];
          const isChecked = opt[key];
          return {
            name: key,
            TransactionType: isChecked ? 'OPT_IN' : 'OPT_OUT'
          };
        });

        customPreferences.push({
          name: preferenceName,
          options: options
        });
      });

      this.payload.push({
        purposes: [
          {
            name: purposeKey,
            customPreferences: customPreferences
          }
        ]
      });
    });
   
    return this.payload;
  }

 generateConsentPayloadwhenWidrawn(): any[] {
    this.payload = []; // Reset payload for each generation
    // Loop over each purpose (e.g. "Marketing Consent (ECP)")
    Object.keys(this.parsedData).forEach(purposeKey => {
      var customPreferences: any[] = [];

      // Loop over each sub-group (e.g. "Communication Method")
      this.parsedData[purposeKey].forEach((preferenceObj: any) => {
        const preferenceName = Object.keys(preferenceObj)[0];
        const optionsArray = preferenceObj[preferenceName];

        const options = optionsArray.map((opt: any) => {
          const key = Object.keys(opt)[0];
          const isChecked = opt[key];
          return {
            name: key,
            TransactionType: isChecked ? 'OPT_IN' : 'OPT_OUT'
          };
        });

        customPreferences.push({
          name: preferenceName,
          options: options
        });
      });



const  filteredData  = customPreferences.map(category  =>  ({
        ...category,
       options:  category.options.filter((option:any)  =>  option.TransactionType  ===  "OPT_IN")
})).filter(category  =>  category.options.length  > 0);
 customPreferences = filteredData;

      this.payload.push({
        purposes: [
          {
            name: purposeKey,
            TransactionType:  purposeKey  ===  "Marketing Consent (ECP)" ?  "CONFIRMED"  :  undefined,
          
            customPreferences: customPreferences
          }
        ]
      });
    });
   
    return this.payload;
  }


  generateConsentUnSubscribePayload(): any[] {

    this.payload = []; // Reset payload for each generation
    // Loop over each purpose (e.g. "Marketing Consent (ECP)")
    Object.keys(this.parsedData).forEach(purposeKey => {
      const customPreferences: any[] = [];

      // Loop over each sub-group (e.g. "Communication Method")
      this.parsedData[purposeKey].forEach((preferenceObj: any) => {
        const preferenceName = Object.keys(preferenceObj)[0];
        const optionsArray = preferenceObj[preferenceName];

        const options = optionsArray.map((opt: any) => {
          const key = Object.keys(opt)[0];
          const isChecked = opt[key];
          return {
            name: key,
            TransactionType: 'OPT_OUT'
          };
        });

        customPreferences.push({
          name: preferenceName,
          options: options
        });
      });

      this.payload.push({
        purposes: [
          {
            name: purposeKey,
            customPreferences: customPreferences
          }
        ]
      });
    });    
    return this.payload;
  }
  updateParsedDataFromInput(input: any[]): void {
  // Flatten selected options for quick lookup
  const selectedOptions = new Set<string>();

  input.forEach(group => {
    group.purposes.forEach((purpose: any) => {
      purpose.customPreferences.forEach((preference: any) => {
        preference.options.forEach((option: any) => {
          selectedOptions.add(option.name);
        });
      });
    });
  });

  Object.keys(this.parsedData).forEach(purposeKey => {
      this.parsedData[purposeKey].forEach((prefObj: any) => {
        const prefKey = Object.keys(prefObj)[0];
        prefObj[prefKey] = prefObj[prefKey].map((opt: any) => {
          const optKey = Object.keys(opt)[0];
          return { [optKey]: selectedOptions.has(optKey) };
        });
      });
    });
  // Define categories to update
  const categories = ["Communication Content", "Communication Method", "Areas of Interest (ECP)"];

 categories.forEach(category => {
  if (this.parsedData[category] && Array.isArray(this.parsedData[category])) {
    this.parsedData[category] = this.parsedData[category].map((opt: any) => ({
      [Object.keys(opt)[0]]: selectedOptions.has(Object.keys(opt)[0])
    }));
  } 
});
}
  transformConsentData(data: any[]): any {
    const result: any = {};
    data.forEach(entry => {
      const key = Object.keys(entry)[0];
      const value = entry[key];

      if (Array.isArray(value)) {
        result[key] = value.map(innerObj => {
          const innerKey = Object.keys(innerObj)[0];
          const innerArray = innerObj[innerKey];

          const transformedArray = innerArray.map((item: string) => {
            return { [item]: false };
          });

          return { [innerKey]: transformedArray };
        });
      } else {
        result[key] = [];
      }
    });
    return result;
  }

  getKey(obj: any): string {
    return Object.keys(obj)[0];
  }

  getLabel(detail: any): string {
    return Object.keys(detail)[0];
  }

  getValue(detail: any): boolean {
    const key = this.getLabel(detail);
    return detail[key];
  }
  onDataChange(data: any) {
    this.inputPhone = data;
  }
  async onChangeCode(event: any) {
    // const temp = this.phoneForm.controls.value;
    // // const phoneUser =temp.internationalNumber.toString().substring(4).trim();
   
    if (this.phoneForm.value.phone !== null || this.phoneForm.value.phone === '') {
      if (this.phoneForm.invalid) {
        this.invalidNo = true;
        this.showButton = false;
      } else {
        this.invalidNo = false;
        this.showButton = true;
      }
    }
  }

  processMarketingConsent(parsedData:  any)  {     

       const  marketingConsent  = parsedData?.[0]?.purposes?.[0]?.status;     

       if  (marketingConsent) {
              this.isMarketingConsentChecked  =  marketingConsent ===  "ACTIVE";
              this.isUnsubscribeConsentChecked  = marketingConsent  ===  "WITHDRAWN";
              this.currentMarketingConsentstatus =  marketingConsent ;
              this.consentFormError =  marketingConsent === 'undefined' ? 'Consent status is undefined' : '';
              
       }      
}

updateMarketingConsentStatus(isChecked: boolean): void {
  const requestBody = {
    profile: {
      marketingconsent: isChecked
    }
  };

  this.httpHelperService.userProfilePatch(requestBody)
    .then((observable: any) => {
      observable.subscribe({
        next: (updatedProfile: any) => {
          console.log('Updated user profile:', updatedProfile);

          if (updatedProfile?.profile?.marketingconsent === isChecked) {
            console.log('Marketing consent updated successfully!');
          } else {
            console.warn('Marketing consent value mismatch!');
          }
        },
        error: (err: any) => {
          console.error('Failed to update marketing consent:', err);
        }
      });
    });
}


  getPreferenceColumns(): any[][] {
    const items = this.parsedData['Marketing Consent (ECP)'] || [];
    const columns: any[][] = [[], []];

    items.forEach((item: any, index: any) => {
      columns[index % 2].push(item);
    });

    return columns;
  }

  isMobilePhoneSMSSelected(): boolean {
    return this.selectedPreferences['Mobile Phone SMS'] === true;
  }
  onPreferenceWithConsentSubmit(): void {
    this.consentFormError =  null;
    if  (this.isMarketingConsentChecked)  {
               if  (this.currentMarketingConsentstatus  ===  'ACTIVE')  {
                this.updateMarketingConsentStatus(true);
                      this.generateConsentPayload();
                }  else  if (this.currentMarketingConsentstatus  ===  'WITHDRAWN')  {  
                  this.updateMarketingConsentStatus(false);
                       this.generateConsentPayloadwhenWidrawn();
                }
        
    // if (this.isMarketingConsentChecked) {
    //   this.generateConsentPayload();
      const marketingConsentEcp = this.payload.find((item: any) =>
        item.purposes.some((p: any) => p.name === "Marketing Consent (ECP)")
      );
      if (!marketingConsentEcp  ||  !marketingConsentEcp.purposes) {
   this.consentFormError  =  "Marketing Consent  (ECP)  data is  missing  or malformed.";  
   this.showPreferredCategories =  true;
   return;
}

      const isSmsSelected = this.checkMobilePhoneSMSOptIn(marketingConsentEcp.purposes);
      //  alert(this.phoneForm.value.phone.internationalNumber);
      //  alert(this.phoneForm.value.phone.internationalNumber);
      // Mark all controls as touched so errors show
      this.phoneForm.markAllAsTouched();

      // Check if phone number is valid
      const phoneControl = this.phoneForm.get('phone');
      // If SMS is selected but the phone is invalid
      if (isSmsSelected && phoneControl?.invalid) {
        this.invalidNo = true;
        phoneControl.markAsTouched();
        return;
      }
      //test if the phone number is valid
      if (isSmsSelected && phoneControl?.valid) {
        const mobileNumber = phoneControl.value?.internationalNumber;
        this.preferencesService.updateMobileNumber(mobileNumber);



        const ecpPurpose = marketingConsentEcp.purposes.find(
          (p: any) => p.name === 'Marketing Consent (ECP)'
        );

        if (ecpPurpose) {
          const commMethod = ecpPurpose.customPreferences.find(
            (pref: any) => pref.name === 'Communication Method'
          );

          if (commMethod) {
            const smsOption = commMethod.options.find(
              (opt: any) => opt.name === 'Mobile Phone SMS'
            );

            if (smsOption && smsOption.TransactionType === 'OPT_IN') {
              smsOption.mobilenumber = mobileNumber;
            }
          }
        }
      }
      this.invalidNo = false;
    
      this.preferencesService.updateMyPreferences([marketingConsentEcp],this.userid);

      this.enableSubmit = true;
    }
    if (this.isUnsubscribeConsentChecked) {     
       this.showPreferredCategories  =  true;
        const  marketingConsentEcp = 
        {
            "purposes": [
                {
                    "name": "Marketing Consent (ECP)",
                    "TransactionType": "WITHDRAWN"
                }
            ]
        }
      this.updateMarketingConsentStatus(false);
      this.preferencesService.updateMyPreferences([marketingConsentEcp],this.userid);
      this.preferencesService.updateMobileNumber('');
      this.enableSubmit = true;
    }
    this.formSubmitted = true;
    this.consentFormSubmitted = true;   
    this.loadPreferencesData();     
    
    setTimeout(() => {
      this.consentFormSubmitted = false;
      this.consentFormError = null;
      this.loadPreferencesData();
    }, 3000);    
  }

  checkMobilePhoneSMSOptIn(data: any[]): boolean {
    const marketingConsent = data.find(
      (consent) => consent.name === 'Marketing Consent (ECP)'
    );

    if (!marketingConsent) return false;

    const communicationMethod = marketingConsent.customPreferences.find(
      (pref: any) => pref.name === 'Communication Method'
    );

    if (!communicationMethod) return false;

    const mobileSMSOption = communicationMethod.options.find(
      (option: any) => option.name === 'Mobile Phone SMS'
    );

    return mobileSMSOption?.TransactionType === 'OPT_IN';
  }
  onFocus() {
    this.showButton = true;
    if (this.phoneForm.invalid) {
      this.invalidNo = true;
      this.showButton = false;
    } else {
      this.invalidNo = false;
      this.showButton = true;
    }
  }

  onBlur() {
    this.showButton = true;
    if (this.phoneForm.invalid) {
      this.invalidNo = true;
      this.showButton = false;
    } else {
      this.invalidNo = false;
      this.showButton = true;
    }
  }

  onInput(event: any) {
    this.showButton = true;
    const mobileNumber  =  this.phoneForm.get('phone')?.value?.internationalNumber;
   if (mobileNumber)  {
      this.preferencesService.updateMobileNumber(mobileNumber);
   }

  }
  onChangeInput(e: any) {
    this.showButton = true;
  }

  loadPhoneNumberComponent() {
  }
  onCheckboxChange(
    detail: any,
    subItem: any,
    subItemKey: string,
    event: Event
  ): void {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;
    const label = Object.keys(detail)[0];
    detail[label] = isChecked; // ✅ Live update parsedData

    // Optional logic for MPC or other special cases
    if (label === 'Mobile Phone SMS') {
      if (isChecked) {
        this.phoneForm.get('phone')?.enable();
      } else {
       this.phoneForm.get('phone')?.reset();
        this.phoneForm.get('phone')?.disable();
        this.phoneForm.get('phone')?.setValue('');
        this.invalidNo = false;
        this.previousValue = this.phoneForm.value.phone?.internationalNumber;;
        this.preferencesService.updateMobileNumber('');
      }
    }


    this.enableSubmit = false;
    

    // Optional: track user preferences
    if (isChecked) {
      this.showPreferredCategories= false;
      
      if (!this.userPreferences.includes(label)) {
        this.userPreferences.push(label);
      }
    } else {      
      this.userPreferences = this.userPreferences.filter(item => item !== label);
    }    

    this.showButton = true; // Show submit button if needed
  
 

  }
//   updateMobileNumber(mobileNumber: string):  void  {
//    this.mobileNumberSource.next(mobileNumber);
// }



  hasSelectedPreferences(): boolean {
    return this.preferences.some(pref => pref.visible) ||
      this.comchannel.some(channel => channel.visible) ||
      this.areaofIntrest.some(area => area.visible);
  }


  toggleConsent() {
    this.consentGiven = this.preferenceForm.get('marketingConsent')?.value;
    const controls = ['news', 'offers', 'email', 'sms'];
    controls.forEach((control) => {
      if (this.consentGiven) {
        this.preferenceForm.get(control)?.enable();
      } else {
        this.preferenceForm.get(control)?.disable();
      }
    });
  }

  isConsentSelected(): boolean {
    return this.isMarketingConsentChecked || this.isUnsubscribeConsentChecked;
  }


  onCheckboxConsentChange(currentCheckbox: string, siblingCheckboxes: string[]): void {

    //alert("You have selected " + currentCheckbox);
    this.enableSubmit = this.isUnsubscribeConsentChecked;

    this[currentCheckbox] = !this[currentCheckbox];
    if (this[currentCheckbox]) {
      siblingCheckboxes.forEach(sibling => this[sibling] = false); // Uncheck all sibling checkboxes
    } else {
      // Ensure state consistency in case of subsequent unchecked logic.
      siblingCheckboxes.forEach(sibling => this[sibling] = false);
    }
    //  alert(this.isUnsubscribeConsentChecked);

  }
  onChangePhone(event: any) {
    this.showButton = true;
  }
}
